/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_ME_REQUEST]: state => {
    state.getMePending = true;
  },

  [types.GET_ME_FAILURE]: state => {
    state.getMePending = false;
    state.getMeSuccess = false;
    state.getMeFailed = true;
  },

  [types.GET_ME_SUCCESS]: (state, data) => {
    state.getMePending = false;
    state.getMeSuccess = true;
    state.getMeFailed = false;

    state.me = data;
  },

  [types.UPDATE_USER_PROFILE_REQUEST]: state => {
    state.updatingProfile = true;
    state.updatingProfileFailed = false;
    state.updatingProfileSuccess = false;
  },

  [types.UPDATE_USER_PROFILE_FAILURE]: state => {
    state.updatingProfileFailed = true;
    state.updatingProfileSuccess = false;
  },

  [types.UPDATE_USER_PROFILE_SUCCESS]: state => {
    state.updatingProfileSuccess = true;
    state.updatingProfileFailed = false;
  },

  [types.GET_GROUPS_REQUEST]: state => {
    state.loadingGroups = true;
    state.loadingGroupsFailed = false;
    state.loadingGroupsSucceeded = false;
  },

  [types.GET_GROUPS_FAILURE]: (state, error) => {
    state.loadingGroupsFailed = true;
    state.loadingGroupsError = error.response;
  },

  [types.GET_GROUPS_SUCCESS]: (state, response) => {
    state.loadingGroups = false;
    state.loadingGroupsFailed = false;
    state.loadingGroupsSucceeded = true;
    state.groups = response.data.results;
  },

  [types.GET_COMPANY_USERS_REQUEST]: state => {
    state.loadingCompanyUsers = true;
    state.loadingCompanyUsersSucceeded = false;
    state.loadingCompanyUsersFailed = false;
  },

  [types.GET_COMPANY_USERS_FAILURE]: (state, error) => {
    state.loadingCompanyUsers = false;
    state.loadingCompanyUsersFailed = true;
    state.loadingCompanyUsersErrors = error.error;
  },

  [types.GET_COMPANY_USERS_SUCCESS]: (state, response) => {
    state.loadingCompanyUsers = false;
    state.loadingCompanyUsersSucceeded = true;
    state.companyUsers = response.data.results;
  },

  [types.UPDATE_COMPANY_USER_REQUEST]: state => {
    state.updateCompanyUserRequest = true;
    state.updateCompanyUserSucceeded = false;
    state.updateCompanyUserFailed = false;
    state.updateCompanyUserErrors = null;
  },

  [types.UPDATE_COMPANY_USER_SUCCESS]: state => {
    state.updateCompanyUserRequest = false;
    state.updateCompanyUserSucceeded = true;
    state.updateCompanyUserFailed = false;
    state.updateCompanyUserErrors = null;
  },

  [types.UPDATE_COMPANY_USER_FAILURE]: (state, error) => {
    state.updateCompanyUserRequest = false;
    state.updateCompanyUserSucceeded = false;
    state.updateCompanyUserFailed = true;
    state.updateCompanyUserErrors = error.response.data;
  },

  [types.UPDATE_USER_LOCALE_REQUEST]: state => {
    state.updateUserLocaleRequest = true;
    state.updateUserLocaleSuccess = false;
    state.updateUserLocaleFailure = false;
  },

  [types.UPDATE_USER_LOCALE_SUCCESS]: (state, response) => {
    state.updateUserLocaleRequest = false;
    state.updateUserLocaleSuccess = true;
    state.updateUserLocaleFailure = false;

    state.userCountryCode = response.data.country_code;
    localStorage.setItem('browserLocale', JSON.stringify(response.data));
  },

  [types.UPDATE_USER_LOCALE_FAILURE]: state => {
    state.updateUserLocaleRequest = false;
    state.updateUserLocaleSuccess = false;
    state.updateUserLocaleFailure = true;
  },

  [types.UPDATE_USER_PASSWORD_SUCCESS]: (state, response) => {
    state.userListSelectedUser = response.userListSelectedUser;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js